import type { ParentType } from '@risksmart-app/domain/src/types/consts/parent-type';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';

import type { AssessmentTypeEnum } from '../types';

export type DocumentAssessmentResultFormIds = Extract<
  ParentType,
  | 'document_assessment_result'
  | 'document_internal_audit_result'
  | 'document_oversight_result'
>;

export const getDocumentAssessmentResultParentType = (
  assessmentMode?: AssessmentTypeEnum
): DocumentAssessmentResultFormIds => {
  switch (assessmentMode) {
    case 'internal_audit_report':
      return Parent_Type_Enum.DocumentInternalAuditResult;
    case 'oversight_assessment':
      return Parent_Type_Enum.DocumentOversightResult;
    case 'rating':
    default:
      return Parent_Type_Enum.DocumentAssessmentResult;
  }
};
